var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2828 20.8678C38.2828 24.3017 35.4991 27.0854 32.0654 27.0854C28.6318 27.0854 25.8481 24.3017 25.8481 20.8678C25.8481 17.4341 28.6318 14.6504 32.0654 14.6504C35.4991 14.6504 38.2828 17.4341 38.2828 20.8678Z",
    stroke: "#704DE7",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0631 39.4663C45.0631 43.8365 39.2426 47.3794 32.063 47.3794C24.8835 47.3794 19.0629 43.8364 19.0629 39.4663C19.0629 35.0962 24.8835 31.5532 32.063 31.5532C39.2426 31.5532 45.0631 35.0962 45.0631 39.4663Z",
    stroke: "#704DE7",
    strokeWidth: 2.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    stroke: "#704DE7",
    strokeWidth: 2.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.dd11290a7b08280c232f0ecb0b680420.svg";
export { ForwardRef as ReactComponent };